import React from 'react'

import AppLink from './AppLink'

interface Props {
  label: string
  linkLabel: string
  link: string
}

const FieldViewLink: React.FC<Props> = ({ label, linkLabel, link }) => {
  return (
    <label className={'w-50'}>
      <span className="name">{label}</span>
      <label className="form-field">
        <AppLink className="field-view-link" label={linkLabel} link={link} />
      </label>
    </label>
  )
}

export default FieldViewLink
